import type { ImportInfo } from '@mcgames/contracts';
import { Button } from '@mcgames/ui';
import { useTranslation } from 'react-i18next';
import { useImportAction } from '../imports-hooks.ts';
import { ErrorText } from './ErrorText.tsx';

/**
 * Cancels a running import at any step; it fails as cancelled, so retry applies afterwards. No
 * confirmation: like a retry, a cancel loses nothing that the retry would not restore.
 */
export function CancelImportButton({ info, size }: { info: ImportInfo; size?: 'sm' }) {
  const { t } = useTranslation('admin');
  const cancel = useImportAction(info, 'cancel');
  return (
    <>
      <Button
        variant="secondary"
        size={size}
        disabled={cancel.isPending}
        onClick={() => cancel.mutate()}
      >
        {t('games.import.cancel')}
      </Button>
      <ErrorText error={cancel.error} />
    </>
  );
}
